import { translate } from '../../../Internationalization';
import CopyAgentBlogScript from './CopyAgentBlogScript/CopyAgentBlogScript';
import flags from '../../../../shared/Flags';
import images from '../../../../config/local/images';
import Loading from '../../../../shared/Loading';
import React from 'react';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import WidgetHeader from '../Header/WidgetHeader';

const widgetHeader = (
	<WidgetHeader
		description={translate('agent.pages.widgets.blog.description')}
		illustration={images.blog.widget.header}
		title={translate('agent.pages.widgets.blog.cta')}
	/>
);

/** @returns {JSX.Element} */
function BlogsWidget() {
	const { isGated, isGettingData } = useIsGated(flags.agent.blogWidget);

	if (isGettingData) {
		return (
			<main>
				{widgetHeader}
				<Loading />
			</main>
		);
	}

	if (isGated) {
		return <main>{widgetHeader}</main>;
	}

	return (
		<main>
			{widgetHeader}
			<CopyAgentBlogScript />
		</main>
	);
}

export default React.memo(BlogsWidget);
